import $ from 'jquery'

$(document).ready(function() {
	const $linkBoxes = $('.link-boxes')
	if ($linkBoxes.length) {
		//MatchHeight
		require('jquery-match-height')
		const linkBoxMatchHeight = $singleLinkBoxes => {
			$singleLinkBoxes.find('.title').matchHeight()
			$singleLinkBoxes.find('.text').matchHeight()
			$singleLinkBoxes.find('.label').matchHeight()
		}

		//Slick?
		const isNarrowed = $('#internal-nav').hasClass('aside-style')
		$linkBoxes.filter('.should-slick').each(function() {
			$(this).slick({
				dots: false,
				autoplay: true,
				arrows: true,
				infinite: true,
				speed: 500,
				autoplaySpeed: 4000,
				slidesToShow: isNarrowed ? 3 : 4,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: isNarrowed ? 3 : 4
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							dots: true
						}
					}
				]
			})

			$(this).on('afterChange', function() {
				linkBoxMatchHeight($(this))
			})
		})

		//Initialise
		$linkBoxes.each(function() {
			linkBoxMatchHeight($(this))
		})
	}
})
